import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import { Page } from '@/core/architecture'

import { ConsoleFavoriteMemberSettingsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleFavoriteMemberSettings Page
 * 推し設定画面
 */
export const ConsoleFavoriteMemberSettings: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <DndProvider backend={HTML5Backend}>
      <ConsoleFavoriteMemberSettingsTemplate state={state} {...actions} />
    </DndProvider>
  )
}
